import { createSelector } from '@reduxjs/toolkit';
import { User } from '../../../../Models/User/User';
import { CLIENT_URL } from '../../../../Utils/Constants';
import { Optional } from '../../../../Utils/Types';
import { storeSelector } from '../../Global/StoreSelector';

const currentUserRun = createSelector(storeSelector, (state) => state.user.currentUser?.run);
const videoSource = createSelector(storeSelector, (state) => state.video.videoSource);
const widgetUrl = createSelector(storeSelector, (state) => {
  const user: Optional<User> = state.user.currentUser;
  if (user) {
    return `${CLIENT_URL}/widget/${user.sessionId}`;
  }
  return undefined;
});
const widgetDisplayMode = createSelector(storeSelector, (state) => state.user.currentUser?.settings.widget.displayMode);
const widgetMoonLanguage = createSelector(
  storeSelector,
  (state) => state.user.currentUser?.settings.widget.moonLanguage
);
const widgetScale = createSelector(storeSelector, (state) => state.user.currentUser?.settings.widget.scale);

export default {
  currentUserRun,
  videoSource,
  widgetUrl,
  widgetDisplayMode,
  widgetMoonLanguage,
  widgetScale
};
